/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetVisitRegistrationDto } from './GetVisitRegistrationDto';
import {
    GetVisitRegistrationDtoFromJSON,
    GetVisitRegistrationDtoFromJSONTyped,
    GetVisitRegistrationDtoToJSON,
} from './GetVisitRegistrationDto';
import type { GetInvoicePaymentDto } from './GetInvoicePaymentDto';
import {
    GetInvoicePaymentDtoFromJSON,
    GetInvoicePaymentDtoFromJSONTyped,
    GetInvoicePaymentDtoToJSON,
} from './GetInvoicePaymentDto';

/**
 * 
 * @export
 * @interface GetPaymentDto
 */
export interface GetPaymentDto {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentDto
     */
    sysNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentDto
     */
    provider: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentDto
     */
    providerPaymentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentDto
     */
    status: GetPaymentDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentDto
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentDto
     */
    mail: string;
    /**
     * 
     * @type {Date}
     * @memberof GetPaymentDto
     */
    creationTs: Date;
    /**
     * 
     * @type {GetVisitRegistrationDto}
     * @memberof GetPaymentDto
     */
    visit?: GetVisitRegistrationDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentDto
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentDto
     */
    isSellDocumentIssued?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentDto
     */
    sellInvoiceAmount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentDto
     */
    sellReceiptAmount?: string | null;
    /**
     * 
     * @type {GetInvoicePaymentDto}
     * @memberof GetPaymentDto
     */
    invoicePayment?: GetInvoicePaymentDto | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentDto
     */
    gatewayId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentDto
     */
    gatewayName?: string | null;
}


/**
 * @export
 */
export const GetPaymentDtoStatusEnum = {
    Created: 'Created',
    Pending: 'Pending',
    Cancelled: 'Cancelled',
    Error: 'Error',
    Success: 'Success',
    Returned: 'Returned'
} as const;
export type GetPaymentDtoStatusEnum = typeof GetPaymentDtoStatusEnum[keyof typeof GetPaymentDtoStatusEnum];


/**
 * Check if a given object implements the GetPaymentDto interface.
 */
export function instanceOfGetPaymentDto(value: object): value is GetPaymentDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sysNumber' in value) || value['sysNumber'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('mail' in value) || value['mail'] === undefined) return false;
    if (!('creationTs' in value) || value['creationTs'] === undefined) return false;
    return true;
}

export function GetPaymentDtoFromJSON(json: any): GetPaymentDto {
    return GetPaymentDtoFromJSONTyped(json, false);
}

export function GetPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sysNumber': json['sysNumber'],
        'provider': json['provider'],
        'providerPaymentId': json['providerPaymentId'] == null ? undefined : json['providerPaymentId'],
        'status': json['status'],
        'amount': json['amount'],
        'currency': json['currency'],
        'mail': json['mail'],
        'creationTs': (new Date(json['creationTs'])),
        'visit': json['visit'] == null ? undefined : GetVisitRegistrationDtoFromJSON(json['visit']),
        'description': json['description'] == null ? undefined : json['description'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'isSellDocumentIssued': json['isSellDocumentIssued'] == null ? undefined : json['isSellDocumentIssued'],
        'sellInvoiceAmount': json['sellInvoiceAmount'] == null ? undefined : json['sellInvoiceAmount'],
        'sellReceiptAmount': json['sellReceiptAmount'] == null ? undefined : json['sellReceiptAmount'],
        'invoicePayment': json['invoicePayment'] == null ? undefined : GetInvoicePaymentDtoFromJSON(json['invoicePayment']),
        'gatewayId': json['gatewayId'] == null ? undefined : json['gatewayId'],
        'gatewayName': json['gatewayName'] == null ? undefined : json['gatewayName'],
    };
}

export function GetPaymentDtoToJSON(value?: GetPaymentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'sysNumber': value['sysNumber'],
        'provider': value['provider'],
        'providerPaymentId': value['providerPaymentId'],
        'status': value['status'],
        'amount': value['amount'],
        'currency': value['currency'],
        'mail': value['mail'],
        'creationTs': ((value['creationTs']).toISOString()),
        'visit': GetVisitRegistrationDtoToJSON(value['visit']),
        'description': value['description'],
        'errorMessage': value['errorMessage'],
        'isSellDocumentIssued': value['isSellDocumentIssued'],
        'sellInvoiceAmount': value['sellInvoiceAmount'],
        'sellReceiptAmount': value['sellReceiptAmount'],
        'invoicePayment': GetInvoicePaymentDtoToJSON(value['invoicePayment']),
        'gatewayId': value['gatewayId'],
        'gatewayName': value['gatewayName'],
    };
}

